<script setup>
import { TooltipProvider as RekaTooltipProvider } from 'reka-ui';

defineProps({
    /**
     * Delay (ms) before the tooltip opens after pointer/focus enters the trigger.
     * @default 150
     */
    delayDuration: {
        type: Number,
        default: 150,
    },
    /**
     * When the user moves between triggers within this window (ms),
     * subsequent tooltips open without re-applying the full delay.
     * @default 300
     */
    skipDelayDuration: {
        type: Number,
        default: 300,
    },
    /**
     * When `false`, hovering the tooltip's own content does not keep it open.
     * Leave `true` for richer tooltips with links inside.
     * @default true
     */
    disableHoverableContent: {
        type: Boolean,
        default: false,
    },
});
</script>

<template>
    <RekaTooltipProvider
        :delay-duration="delayDuration"
        :skip-delay-duration="skipDelayDuration"
        :disable-hoverable-content="disableHoverableContent"
    >
        <slot />
    </RekaTooltipProvider>
</template>
